import React, { useContext } from 'react';
import { Redirect } from 'react-router';
import { isEmpty } from 'check-tool';

import { getLanguage } from 'common/i18n';

import MenuTop from 'components/MenuTop';
import MenuLeft from 'components/MenuLeft';
import { AuthContext } from 'AuthProvider';


const NotificationListPage = () => {
  const lang = getLanguage();
  const { currentUser } = useContext(AuthContext);

  if (isEmpty(currentUser)) {
    return <Redirect to="/signin" />;
  }

  return (
    <div>
      <MenuTop lang={lang} user={currentUser} />
      <div className="main-container ace-save-state" id="main-container">
        <MenuLeft lang={lang} user={currentUser} currentPage="notification" />
        <div className="main-content">
          <div className="main-content-inner">
            <div className="breadcrumbs ace-save-state" id="breadcrumbs">
              <ul className="breadcrumb">
                <li>
                  <i className="ace-icon fa fa-home home-icon"></i>
                  <a href="/">Главная</a>
                </li>
                <li className="active">Push-сообщения</li>
              </ul>
            </div>
            <div className="page-content">
              <div className="row">
                <div className="col-xs-12 text-center">
                  <a href="/notification/iquestion" className="btn btn-app btn-primary btn-success radius">
										<i className="ace-icon fa fa-pencil-square-o bigger-230"></i>
										iQuestion
									</a>
                  <a href="/notification/magic-ball" className="btn btn-app btn-primary btn-purple radius ">
										<i className="ace-icon fa fa-pencil-square-o bigger-230"></i>
										Magic Ball
									</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationListPage;
